module.exports = __webpack_public_path__ + "img/mCloud.fa8b03ce.svg";